import { render, staticRenderFns } from "./insuranceFile.vue?vue&type=template&id=6903404f&scoped=true&"
import script from "./insuranceFile.vue?vue&type=script&lang=js&"
export * from "./insuranceFile.vue?vue&type=script&lang=js&"
import style0 from "./insuranceFile.vue?vue&type=style&index=0&id=6903404f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6903404f",
  null
  
)

export default component.exports